(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      
      // Threshold: header stays fixed until user scrolls past this percentage
      this.stickyThresholdPercent = 10;
      
      // Threshold: logo becomes visible after scrolling past this percentage
      this.logoVisibleThresholdPercent = 5;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Always start with sticky header visible
      this.header.classList.add('shopify-section-header-sticky');

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isHidden = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    getScrollPercent() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      return docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollPercent = this.getScrollPercent();

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Logo visibility: show logo when scrolled past 5%
      if (scrollPercent > this.logoVisibleThresholdPercent) {
        this.header.classList.add('logo-visible');
      } else {
        this.header.classList.remove('logo-visible');
      }

      // If within first 10% of page OR "always" sticky mode, always show header
      if (scrollPercent <= this.stickyThresholdPercent || this.headerIsAlwaysSticky) {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
        this.header.classList.add('shopify-section-header-sticky');
        if (this.isHidden) {
          this.reveal();
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      // Beyond threshold: use on-scroll-up behavior with premium animations
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling DOWN - hide header
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        if (!this.isHidden) {
          this.hide();
        }
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling UP - show header
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          if (this.isHidden) {
            this.reveal();
          }
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          if (!this.isHidden) {
            this.hide();
          }
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.isHidden = true;
      this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.isHidden = false;
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
    }

    reset() {
      this.isHidden = false;
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
